// extracted by mini-css-extract-plugin
module.exports = {"root":"ScaleOperations_root__86o6B","background":"ScaleOperations_background__j0h2d","scaleCircles":"ScaleOperations_scaleCircles__H_mXT","active":"ScaleOperations_active__iKAG9"};